import { render, staticRenderFns } from "./Cancellations.vue?vue&type=template&id=47477806&scoped=true&"
import script from "./Cancellations.vue?vue&type=script&lang=js&"
export * from "./Cancellations.vue?vue&type=script&lang=js&"
import style0 from "./Cancellations.vue?vue&type=style&index=0&id=47477806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47477806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47477806')) {
      api.createRecord('47477806', component.options)
    } else {
      api.reload('47477806', component.options)
    }
    module.hot.accept("./Cancellations.vue?vue&type=template&id=47477806&scoped=true&", function () {
      api.rerender('47477806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Cancellations.vue"
export default component.exports